import { css } from 'styled-components';

const sizes = {
  phone_sm: 320,
  phone_md: 375,
  phone_l: 430, //425
  tablet_sm: 640,
  tablet: 768,
  tablet_l: 992,
  laptop_sm: 1024, // VGA
  laptop_md: 1280, // HD
  laptop_md_to_l: 1315, // Added for some check
  laptop_l: 1440, // Full-HD
  laptop_l_to_xl: 1600,
  laptop_xl: 1980, //
  laptop_xxl: 2560, //2k
};

export const device = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label]}px) {
      ${css(...args)}
    }
  `;
  return acc;
}, {});
